import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function Domain__loadingSkeleton() {
    return (
        <React.Fragment>
            <div className="overflow-hidden">
                <div className="d-flex">
                    <div>
                        <Skeleton count={1} height={20} width={150} />
                    </div>
                    <div className="ms-auto">
                        <Skeleton count={1} height={20} width={100} />
                        <Skeleton count={1} height={20} width={80} className="ms-3" />
                        <Skeleton count={1} height={20} width={80} className="ms-3" />
                    </div>
                </div>
                <div className="ms-auto">
                    <div className="mb-3">

                    </div>
                    <div className="mb-2">
                        <Skeleton count={1} height={20} width={100} />
                    </div>
                    <div className="">
                        <Skeleton count={1} height={20} width={200} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default memo(Domain__loadingSkeleton)